import { fetchJSON } from '@hc-frontend/utils'
import { API_PIVOTHEALTH } from 'core/constants/endpoints'
import parseResponse from './parseResponse'

interface QuestionProps {
  products: string[]
  agentId: string
  stateAcronym: string
  multiCarrier?: boolean
}

export function getQuestions({
  products,
  stateAcronym,
  agentId,
  multiCarrier = false
}: QuestionProps): Promise<ComplianceQuestion[]> {
  return fetchJSON(
    `${API_PIVOTHEALTH}/compliance/v3/questions?productLines=${products}&state=${stateAcronym}&agentId=${agentId}&multiCarrier=${multiCarrier}`
  )
    .then(request => request.parsedBody)
    .then(parseResponse)
}
